const getMetaContent = (key, options) => options[key] ? options[key] : null;
export default getMetaContent;
//# sourceMappingURL=get-meta-content.js.map